import $c from '@/services/api/lib/container'

export default {
  loadCustomers (data) {
    let _sortBy = data.descending ? '-' : ''
    _sortBy += data.sortBy

    return $c.get('customer')
      .page(data.page || 1)
      .limit(data.rowsPerPage || 25)
      .orderBy(_sortBy)
      .getFullData()
  }
}
